export const polygonOptions = {
  strokeWeight: 3,
  fillOpacity: 0.28,
  editable: false,
  fillColor: '#1F4E79',
  strokeColor: '#FFFFFF',
  strokeOpacity: 1,
};

// Screen-pixel radius within which a drawing vertex snaps to an existing roof corner.
// Kept in screen pixels so the snap "feel" stays consistent across map zoom levels.
export const ROOF_VERTEX_SNAP_THRESHOLD_PX = 15;
